<template>
  <div>
    <section role="side-modal">
      <side-modal :sides="navs" @cancela="cancela()">
        <template :slot="navs[0].identidade">
          <div class="side-body">
            <upload-arquivos :api="apiUrl" :endPoint="endPointUpload" :arquivos="anexosTemporarios"
              :podeDeletar="mostraDelete" ref="uploader"/>
          </div>
          <div class="side-footer">
            <botao tipo="button" estilo="cheio-cinza" rotulo="Cancelar" icone="cancela-modal" @clicado="cancela()" />
            <botao tipo="button" estilo="cheio-verde" rotulo="Enviar" icone="fa-upload"
              @clicado="enviaArquivo(cadastrado)" />
          </div>
        </template>
      </side-modal>
    </section>
    <section role="form">
      <div class="main-container container">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <h4 v-show="mostraTituloUpload">
                  Envio de Arquivos
                  <span v-if="cadastrado.mostraMultiplosRegistros">- {{ cadastrado.registro | formataRegistro }}</span>
                </h4>
                <h4 v-show="mostraTituloEnvio">
                  Envio de Atualização Cadastral
                  <span v-if="cadastrado.mostraMultiplosRegistros">- {{ cadastrado.registro | formataRegistro }}</span>
                </h4>
                <h4 v-show="mostraTituloFinalizado">
                  Atualização Cadastral Finalizada
                  <span v-if="cadastrado.mostraMultiplosRegistros">- {{ cadastrado.registro | formataRegistro }}</span>
                </h4>
                <div class="row">
                  <form>
                    <div class="col-md-12">
                      <div class="row row-field">
                        <div v-show="salvando">
                          <h2 class="carregando" style="padding-top: 40px;">
                            Salvando...
                          </h2>
                        </div>
                        <div v-if="cadastrado.status === Status.RECADASTRAMENTO_PENDENTE">
                          <p>
                            Caso não haja alteração e todos os seus dados estejam
                            corretos, clique em
                            <strong>CONFIRMAR</strong> para enviar seu
                            recadastramento.
                          </p>
                        </div>
                        <div v-else>
                          <!--
                          
                          <div v-show="mostraFazerUpload || mostraUploadClaro">
                          -->
                          <div v-show="tipoButao === 'Anexar' || tipoButao === 'Enviar'">
                            <p>
                              Clique em
                              <strong>ANEXAR</strong> para fazer o upload (envio
                              de arquivos digitais) dos seus documentos
                              digitalizados para suas alterações serem
                              <strong>validadas</strong>

                              <!--
                              
                              <span v-show="mostraFazerUpload">
                              -->
                              <span v-show="tipoButao === 'Anexar'">
                                , e abrir a opção
                                <strong>SALVAR</strong> </span>.
                            </p>
                            <p>
                              De acordo com suas alterações, segue a lista dos
                              documentos necessários
                              <strong>(frente e verso)</strong>:
                            </p>
                            <ul v-for="documento of listaDocumentosExigidos" :key="documento">
                              <li>{{ documento }}</li>
                            </ul>

                          </div>

                          <!--
                          
                          <p v-show="mostraEnviar">
                          -->
                          <p v-show="tipoButao === 'Enviar'">    
                            Caso todos os campos a serem alterados estiverem
                            completos e de acordo com seus dados mais atuais,
                            clique em
                            <strong>ENVIAR</strong> para finalizar seu
                            recadastramento.
                          </p>
                        </div>
                        <div class="espacado">
                          <botao 
                            estilo="cheio-verde-lg" 
                            rotulo="Confirmar" 
                            icone="ok-modal" 
                            v-if="cadastrado.status === Status.RECADASTRAMENTO_PENDENTE"
                            @clicado="confirma(cadastrado)" 
                            :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" 
                          />
                          <template v-else>
                            <botao 
                              estilo="cheio-verde-lg" 
                              rotulo="Anexar" 
                              icone="fa-upload" 
                              v-show="tipoButao === 'Anexar' && !this.salvando || situacaoInicial == Status.ALTERADO"
                              @clicado="selecionaArquivo()" 
                              :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" 
                            />
                            <botao 
                              estilo="cheio-verde-lg" 
                              rotulo="Enviar" 
                              icone="fa-send" 
                              v-show="tipoButao === 'Enviar'"
                              @clicado="salvaValidado(cadastrado)" 
                              :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" 
                            />
                          </template>
                          <botao estilo="cheio-verde-lg" rotulo="Ver Protocolo" icone="fa-info-circle"
                            v-show="mostraFinalizado" @clicado="$router.push({ name: 'Fim' })" :disabled="cadastrado.lancamentoPermitido" />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!--
            
            <div class="card card-default" v-show="mostraUploadClaro">
            -->
            <div class="card card-default" v-show="tipoButao === 'Anexar' || situacaoInicial == Status.ALTERADO">
              <div class="card-content">
                <h4>Envio de Atualização Cadastral</h4>
                <div class="row">
                  <form>
                    <div class="col-md-12">
                      <p>
                        A atualização ficará
                        <strong>pendente de anexação</strong>, de documentação
                        comprobatória (digitalizada).
                      </p>
                      <p>
                        As informações
                        <strong>não validadas</strong> pelo setor competente
                        (por inconsistência ou ausência de documentação
                        comprobatória), <strong>serão descartadas</strong>,
                        mantendo-se os dados já constantes no sistema.
                      </p>
                      <div class="espacado">
                        <botao estilo="cheio-verde-lg" rotulo="Salvar" icone="salvar"
                          @clicado="salvaAlterado(cadastrado)" :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="controller">
      <div class="container footer-controller">
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <botao estilo="vazado-verde-esq" rotulo="Voltar" icone="voltar" @clicado="volta()" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue';
import Botao from '@/components/botao';
import SideModal from '@/components/side-modal';
import UploadArquivos from '@/components/upload-arquivos';
import StringHelper from '@/helpers/StringHelper';
import ErrorHelper from '@/helpers/ErrorHelper';
import Hash from 'object-hash';
import RecadastramentoService from '@/services/recadastramentoService';
import Status from './status';


export default {
  name: 'Envio',

  components: {
    Botao,
    SideModal,
    UploadArquivos,
  },

  data() {
    return {
      Status,
      cadastrado: this.$store.state.funcionarioCadastrado,
      apiUrl: this.$root.$data.apiUrl,
      endPointUpload: '',
      salvando: false,
      apiErrors: null,
      totalAlteracoes: 0,
      anexosTemporarios: [],
      situacaoInicial: '',
      tipoButao:'',
      camposAlterados : {
        grupoContato: {
          isValidado: false,
          email: false,
          dddCelular: false,
          numeroCelular: false,
          dddTelefone: false,
          numeroTelefone: false,
        },
        grupoNome: {
          isValidado: true,
          nome: false,
        },
        grupoRg: {
          isValidado: true,
          rg: false,
        },
        grupoTituloEleitor: {
          isValidado: true,
          tituloEleitor: false,
        },
        grupoPispasep: {
          isValidado: true,
          pisPasep: false,
        },
        grupoFiliacao: {
          isValidado: true,
          pai: false,
          mae: false,
        },
        grupoEndereco: {
          isValidado: true,
          cep: false,
          tipoLogradouro: false,
          logradouro: false,
          numero: false,
          complemento: false,
          bairro: false,
          cidade: false,
          uf: false,
          georreferenciado: false,
        },
        grupoGenero: {
          isValidado: false,
          genero: false,
          orientacaoSexual: false,
        },
        grupoEstadoCivil:{
          isValidado: true,
          estadoCivil: false,
        },
        grupoCNH:{
          isValidado: true,
          cnh: false,
          categoria: false,
          validade: false,
        },
        grupoDependentes:{
          isValidado: true,
          dependentes: false,
        },
        grupoOrgaoClasse:{
          isValidado: true,
          orgaoClasse: false,
        },
        grupoDataNascimento:{
          isValidado: true,
          dataNascimento: false,
        },
        grupoRacaCor:{
          isValidado: false,
          racaCor: false,
        },
        grupoCidadeNascimento:{
          isValidado: true,
          cidadeNaturalidade: false,
          ufNaturalidade: false
        },
      },
      navs: [
        {
          titulo: 'Atualização Cadastral',
          subtitulo: 'Documentos',
          subtDetalhe: 'Envio de Arquivos',
          largura: 600,
          identidade: 'upload',
          abreProximo: false,
          aberto: false,
        },
      ],
      verificacaoRealizada: false
    };
  },

  computed: {
    tituloResponsivo() {
      return window.innerWidth <= 540 ? 'Atualização Cadastral' : 'Atualização Cadastral';
    },
    situacaoRecad() {
      return this.$store.getters.getSituacaoRecad;
    },
    mostraConfirmar() {
      return (
        this.cadastrado.status === Status.RECADASTRAMENTO_PENDENTE &&
        !this.cadastrado.validacaoPendente &&
        !this.cadastrado.alteracoes.some(
          item => item.status === Status.NAO_VALIDADO
        ) &&
        !this.cadastrado.ultimoProtocolo
      );
    },
    mostraEnviar() {
      return (
        this.cadastrado.status === Status.SEM_VALIDACAO &&
        !this.cadastrado.validacaoPendente
      );
    },
    mostraFazerUpload() {
      return (
        this.cadastrado.status === Status.COM_VALIDACAO &&
        !this.cadastrado.validacaoPendente &&
        this.verificaAlteracoes()
      );
    },
    mostraUploadClaro() {
      return (
        this.verificaAlteracoes() &&
        (this.cadastrado.status === Status.ALTERADO ||
          !!this.cadastrado.validacaoPendente ||
          this.cadastrado.alteracoes.some(
            item => item.status === Status.NAO_VALIDADO
          )) &&
        !this.salvando
      );
    },
    mostraSalvar() {
      return (
        (this.cadastrado.status === Status.ALTERADO ||
          !!this.cadastrado.validacaoPendente) &&
        !this.salvando &&
        this.verificaAlteracoes()
      );
    },
    listaDocumentosExigidos() {
      let documentosDistintos = [];
      if (this.cadastrado.alteracoes) {
        const documentosPendentes = this.cadastrado.alteracoes.filter(
          item =>
            item.status === Status.PENDENTE_DE_VALIDACAO ||
            item.status === Status.NAO_VALIDADO,
        );
        const documentosMensagens = this.incluiMensagem(
          documentosPendentes,
          this.cadastrado.documentosExigidos,
        );
        documentosDistintos = documentosMensagens.filter(
          (value, index, array) => array.indexOf(value) === index,
        );
      }
      return documentosDistintos;
    },
    mostraDelete() {
      if (this.cadastrado.alteracoes.length) {
        let validaveis = this.cadastrado.alteracoes.filter(
          item => item.grupo !== 'contato' && item.grupo !== 'racaCor',
        );
        let existeNaoDeletavel = validaveis.some(
          item =>
            item.status === Status.VALIDADO ||
            item.status === Status.NAO_VALIDADO ||
            item.status === Status.ATUALIZADO,
        );
        let ehDeletavel = !existeNaoDeletavel;

        return ehDeletavel;
      }
      return true;
    },
    mostraFinalizado() {
      return (
        !this.mostraConfirmar &&
        !this.mostraEnviar &&
        !this.mostraFazerUpload &&
        !this.mostraUploadClaro &&
        !this.salvando &&
        this.cadastrado.status !== Status.RECADASTRAMENTO_PENDENTE
      );
    },
    mostraTituloEnvio() {
      // return (
      //   this.cadastrado.status === Status.RECADASTRAMENTO_PENDENTE ||
      //   this.mostraConfirmar ||
      //   this.mostraEnviar
      // );
      return (
        this.cadastrado.status === Status.RECADASTRAMENTO_PENDENTE ||
        this.situacaoInicial == Status.ALTERADO ||
        this.mostraConfirmar ||
        this.mostraEnviar
      );
    },
    mostraTituloUpload() {
      // return (
      //   this.mostraFazerUpload ||
      //   this.mostraUploadClaro 
      // );
      // return (
      //   this.mostraFazerUpload ||
      //   this.mostraUploadClaro
      // );

      return (
        this.mostraFazerUpload 
      );
    },
    mostraTituloFinalizado() {
      return this.mostraFinalizado;
    },
  },

  methods: {
    abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
    },
    cancela() {
      this.fechaModal('upload');
      this.limpaModal();
    },
    limpaModal() {
      this.$eventBus.$emit('limpa-uploads');
    },
    novo() {
      this.errors.clear();
    },
    mesclarAnexos(){
      this.cadastrado.anexos = this.cadastrado.anexos.concat(this.anexosTemporarios);
    },
    limparEstadoLocal() {
      this.anexosTemporarios = [];
      this.totalAlteracoes = 0;
      this.situacaoInicial = "";
      this.camposAlterados = Object.keys(this.camposAlterados).reduce((acc, key) => {
        acc[key] = { ...this.camposAlterados[key], ...Object.fromEntries(
          Object.entries(this.camposAlterados[key]).map(([k, v]) => [k, k === 'isValidado' ? v : false])
        )};
        return acc;
      }, {});
    },
    determinarBotao() {
      this.tipoButao = ""
      const cadastroModelo = this.$store.state.cadastroModelo;
      const rgAtual = this.cadastrado.pessoa.rg ? this.cadastrado.pessoa.rg : null;


      const rgOriginal = cadastroModelo.pessoa.rg ? cadastroModelo.pessoa.rg : null;

      const enderecoAtual = this.normalizaEndereco(this.cadastrado.pessoa.endereco || {});
      const enderecoOriginal = this.normalizaEndereco(cadastroModelo.pessoa.endereco || {});

      const contatoAtual = this.normalizaContato(this.cadastrado.pessoa.contato || {});
      const contatoOriginal = this.normalizaContato(this.$store.state.cadastroModelo.pessoa.contato || {});

      const tituloAtual = this.cadastrado.pessoa.tituloEleitor ? this.cadastrado.pessoa.tituloEleitor : null;
      const tituloOriginal = cadastroModelo.pessoa.tituloEleitor ? cadastroModelo.pessoa.tituloEleitor : null;
      
      const dadosPessoaisAtuais = this.normalizaDadosPessoais(this.cadastrado.pessoa);
      const dadosPessoaisOriginais = this.normalizaDadosPessoais(cadastroModelo.pessoa);

      // PIS/PASEP
      const pisPasepAtual = this.cadastrado.pessoa.pisPasep;
      const pisPasepOriginal = cadastroModelo.pessoa.pisPasep;
      
      // Órgão de Classe
      const orgaoClasseAtual = this.cadastrado.pessoa.orgaoClasse ? this.cadastrado.pessoa.orgaoClasse : null;
      const orgaoClasseOriginal = cadastroModelo.pessoa.orgaoClasse ? cadastroModelo.pessoa.orgaoClasse : null;
      
      // CNH
      const cnhAtual = this.cadastrado.pessoa.cnh ? this.cadastrado.pessoa.cnh : null;
      const cnhOriginal = cadastroModelo.pessoa.cnh ? cadastroModelo.pessoa.cnh : null;
      
      // Verificação para filiação (nome do pai e da mãe)
      const paiAtual = this.cadastrado.pessoa.filiacao ? this.cadastrado.pessoa.filiacao.pai : null;
      const paiOriginal = cadastroModelo.pessoa.filiacao ? cadastroModelo.pessoa.filiacao.pai : null;
      
      const maeAtual = this.cadastrado.pessoa.filiacao ? this.cadastrado.pessoa.filiacao.mae : null;
      const maeOriginal = cadastroModelo.pessoa.filiacao ? cadastroModelo.pessoa.filiacao.mae : null;
      
      const rgAtualNormalizado = this.normalizaRG(rgAtual);
      const rgOriginalNormalizado = this.normalizaRG(rgOriginal);
      
      const tituloAtualNormalizado = this.normalizaTitulo(tituloAtual);
      const tituloOriginalNormalizado = this.normalizaTitulo(tituloOriginal);
      
      const pisPasepAtualLimpo = pisPasepAtual ? String(pisPasepAtual).replace(/\D/g, '') : null;
      const pisPasepOriginalLimpo = pisPasepOriginal ? String(pisPasepOriginal).replace(/\D/g, '') : null;
      
      const orgaoClasseAtualNormalizado = this.normalizaOrgaoClasse(orgaoClasseAtual);
      const orgaoClasseOriginalNormalizado = this.normalizaOrgaoClasse(orgaoClasseOriginal);

      const dataNascimentoAlterada = dadosPessoaisAtuais.dataNascimento !== dadosPessoaisOriginais.dataNascimento;
      const racaCorAlterada = dadosPessoaisAtuais.racaCor !== dadosPessoaisOriginais.racaCor;
      const estadoCivilAlterado = dadosPessoaisAtuais.estadoCivil !== dadosPessoaisOriginais.estadoCivil;
      const cidadeNatalidadeAlterada = dadosPessoaisAtuais.naturalidade.cidade !== dadosPessoaisOriginais.naturalidade.cidade;
      const ufNatalidadeAlterada = dadosPessoaisAtuais.naturalidade.uf !== dadosPessoaisOriginais.naturalidade.uf;

      const orientacaoSexualAlterada = JSON.stringify(dadosPessoaisAtuais.orientacaoSexual) !== JSON.stringify(dadosPessoaisOriginais.orientacaoSexual);
      const identidadeGeneroAlterada = JSON.stringify(dadosPessoaisAtuais.genero) !== JSON.stringify(dadosPessoaisOriginais.genero);

      const cnhAtualNormalizado = this.normalizaCNH(cnhAtual);
      const cnhOriginalNormalizado = this.normalizaCNH(cnhOriginal);

      const emailAlterado = contatoAtual.email !== contatoOriginal.email;
      const dddCelularAlterado = contatoAtual.dddCelular !== contatoOriginal.dddCelular;
      const numeroCelularAlterado = contatoAtual.numeroCelular !== contatoOriginal.numeroCelular;
      const dddTelefoneAlterado = contatoAtual.dddTelefone !== contatoOriginal.dddTelefone;
      const numeroTelefoneAlterado = contatoAtual.numeroTelefone !== contatoOriginal.numeroTelefone;
    
      const temAlteracoesRG = JSON.stringify(rgAtualNormalizado) !== JSON.stringify(rgOriginalNormalizado);
      const temAlteracoesTitulo = JSON.stringify(tituloAtualNormalizado) !== JSON.stringify(tituloOriginalNormalizado);
      const temAlteracoesPisPasep = pisPasepAtualLimpo !== pisPasepOriginalLimpo;
      const temAlteracoesOrgaoClasse = JSON.stringify(orgaoClasseAtualNormalizado) !== JSON.stringify(orgaoClasseOriginalNormalizado);
      const temAlteracoesCNH = JSON.stringify(cnhAtualNormalizado) !== JSON.stringify(cnhOriginalNormalizado);
      
      const cepAlterado = enderecoAtual.cep !== enderecoOriginal.cep;
      const tipoLogradouroAlterado = enderecoAtual.tipoLogradouro !== enderecoOriginal.tipoLogradouro;
      const logradouroAlterado = enderecoAtual.logradouro !== enderecoOriginal.logradouro;
      const numeroAlterado = enderecoAtual.numero !== enderecoOriginal.numero;
      const complementoAlterado = enderecoAtual.complemento !== enderecoOriginal.complemento;
      const bairroAlterado = enderecoAtual.bairro !== enderecoOriginal.bairro;
      const cidadeAlterado = enderecoAtual.cidade !== enderecoOriginal.cidade;
      const ufAlterado = enderecoAtual.uf !== enderecoOriginal.uf;
      const georreferenciadoAlterado = enderecoAtual.georreferenciado !== enderecoOriginal.georreferenciado;
      
      const dependentesAtuais = this.cadastrado.pessoa.dependentes || [];
      const dependentesOriginais = cadastroModelo.pessoa.dependentes || [];

      const temAlteracoesDependentes = JSON.stringify(dependentesAtuais) !== JSON.stringify(dependentesOriginais);

       this.camposAlterados.grupoFiliacao.pai = paiAtual !== paiOriginal;
       this.camposAlterados.grupoFiliacao.mae = maeAtual !== maeOriginal;

       this.camposAlterados.grupoContato.email = emailAlterado;
       this.camposAlterados.grupoContato.dddCelular = dddCelularAlterado;
       this.camposAlterados.grupoContato.numeroCelular = numeroCelularAlterado;
       this.camposAlterados.grupoContato.dddTelefone = dddTelefoneAlterado;
       this.camposAlterados.grupoContato.numeroTelefone = numeroTelefoneAlterado;
      
       this.camposAlterados.grupoRg.rg = temAlteracoesRG;
       
       this.camposAlterados.grupoTituloEleitor.tituloEleitor = temAlteracoesTitulo;
       this.camposAlterados.grupoPispasep.pisPasep = temAlteracoesPisPasep;
       this.camposAlterados.grupoOrgaoClasse.orgaoClasse = temAlteracoesOrgaoClasse;
       this.camposAlterados.grupoCNH.cnh = temAlteracoesCNH;

       this.camposAlterados.grupoEndereco.cep = cepAlterado;
       this.camposAlterados.grupoEndereco.tipoLogradouro = tipoLogradouroAlterado;
       this.camposAlterados.grupoEndereco.logradouro = logradouroAlterado;
       this.camposAlterados.grupoEndereco.numero = numeroAlterado;
       this.camposAlterados.grupoEndereco.complemento = complementoAlterado;
       this.camposAlterados.grupoEndereco.bairro = bairroAlterado;
       this.camposAlterados.grupoEndereco.cidade = cidadeAlterado;
       this.camposAlterados.grupoEndereco.uf = ufAlterado;
       this.camposAlterados.grupoEndereco.georreferenciado = georreferenciadoAlterado;

       this.camposAlterados.grupoDataNascimento.dataNascimento = dataNascimentoAlterada;
       this.camposAlterados.grupoRacaCor.racaCor = racaCorAlterada;
       this.camposAlterados.grupoEstadoCivil.estadoCivil = estadoCivilAlterado;

       this.camposAlterados.grupoCidadeNascimento.cidadeNaturalidade = cidadeNatalidadeAlterada;
       this.camposAlterados.grupoCidadeNascimento.ufNaturalidade = ufNatalidadeAlterada;

       this.camposAlterados.grupoGenero.orientacaoSexual = orientacaoSexualAlterada;
       this.camposAlterados.grupoGenero.genero = identidadeGeneroAlterada;

       this.camposAlterados.grupoDependentes.dependentes = temAlteracoesDependentes;

       // Adicionando o monitoramento do campo nome
       this.camposAlterados.grupoNome.nome = dadosPessoaisAtuais.nome !== dadosPessoaisOriginais.nome;

      let contadorValidadosAlterados = this.contarGruposValidadosAlterados(this.camposAlterados);  
      let contadorInvalidadosAlterados = this.contarGruposInvalidadosAlterados(this.camposAlterados);
      // TESTE DO TIPO DE GENERO
      if (typeof this.cadastrado.pessoa.genero === 'object') {
        console.log('Gênero é um objeto:', this.cadastrado.pessoa.genero);
      } else if (typeof this.cadastrado.pessoa.genero === 'string') {
        console.log('Gênero é uma string:', this.cadastrado.pessoa.genero);
      }

  // TESTE DO TIPO DE ORIENTACAO SEXUAL
      if (typeof this.cadastrado.pessoa.orientacaoSexual === 'object') {
        console.log('Orientação Sexual é um objeto:', this.cadastrado.pessoa.orientacaoSexual);
      } else if (typeof this.cadastrado.pessoa.orientacaoSexual === 'string') {
        console.log('Orientação Sexual é uma string:', this.cadastrado.pessoa.orientacaoSexual);
      }

      console.log(`Contador Validados Alterados: ${contadorValidadosAlterados}`); 
      console.log(`Contador Invalidados Alterados: ${contadorInvalidadosAlterados}`);

      console.log(`Orientação Sexual Atual:${dadosPessoaisAtuais.orientacaoSexual}`);
      console.log(`Orientação Sexual Original:${dadosPessoaisOriginais.orientacaoSexual}`);

      console.log(`Identidade de Gênero Atual:${dadosPessoaisAtuais.genero}`);
      console.log(`Identidade de Gênero Original:${dadosPessoaisOriginais.genero}`);

     // if (this.cadastrado.status === Status.RECADASTRAMENTO_PENDENTE) {
        if (contadorValidadosAlterados === 0 && contadorInvalidadosAlterados === 0) {
            this.tipoButao = "Confirmar"; // Nada foi alterado
        } else if (contadorValidadosAlterados === 0 && contadorInvalidadosAlterados > 0) {
            this.tipoButao = "Enviar"; // Apenas grupos sem validação foram alterados
        } else {
            this.totalAlteracoes = contadorValidadosAlterados
            this.tipoButao = "Anexar"; // Pelo menos um grupo com validação foi alterado
        }
     
     // }
    },
    contarGruposValidadosAlterados(obj) {
          let count = 0;
  
          for (const key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
              // Verifica se é um grupo validado (tem isValidado === true)
              if (obj[key].isValidado === true) {
                // Verifica se pelo menos um campo (exceto isValidado) está true
                const camposAlterados = Object.entries(obj[key]).some(
                  ([subKey, value]) => subKey !== 'isValidado' && value === true
                );
                
                if (camposAlterados) {
                  count++;
                }
              }
              count += this.contarGruposValidadosAlterados(obj[key]);
            }
          } 
          return count;
      },
      contarGruposInvalidadosAlterados(obj) {
          let count = 0;

          for (const key in obj) {
              if (typeof obj[key] === 'object' && obj[key] !== null) {
                  // Verifica se é um grupo invalidado (isValidado === false)
                  if (obj[key].isValidado === false) {
                      // Verifica se pelo menos um campo (exceto isValidado) está true (alterado)
                      const camposAlterados = Object.entries(obj[key]).some(
                          ([subKey, value]) => subKey !== 'isValidado' && value === true
                      );
                      
                      if (camposAlterados) {
                          count++;
                      }
                  }
                  count += this.contarGruposInvalidadosAlterados(obj[key]);
              }
          } 
          return count;
      },
    // Validação de CPF
    validaCPF(cpf) {
      // Remove caracteres não numéricos
      cpf = cpf.replace(/\D/g, '');
      
      // Verifica se tem 11 dígitos
      if (cpf.length !== 11) return false;
      
      // Verifica se todos os dígitos são iguais
      if (/^(\d)\1+$/.test(cpf)) return false;
      
      // Validação do primeiro dígito verificador
      let soma = 0;
      for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let resto = 11 - (soma % 11);
      let dv1 = resto > 9 ? 0 : resto;
      
      // Validação do segundo dígito verificador
      soma = 0;
      for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i);
      }
      resto = 11 - (soma % 11);
      let dv2 = resto > 9 ? 0 : resto;
      
      // Verifica se os dígitos verificadores estão corretos
      return (parseInt(cpf.charAt(9)) === dv1 && parseInt(cpf.charAt(10)) === dv2);
    },
    // Verifica CPFs dos dependentes
    verificaCPFsDependentes() {
      if (!this.cadastrado.pessoa || !this.cadastrado.pessoa.dependentes) return true;
      
      const dependentesComCPFInvalido = this.cadastrado.pessoa.dependentes.filter(dependente => {
        // Se não tiver CPF ou o CPF for inválido
        return !dependente.cpfDependente || !this.validaCPF(dependente.cpfDependente);
      });
      
      if (dependentesComCPFInvalido.length > 0) {
        let mensagem = 'Os seguintes dependentes possuem CPF inválido ou não preenchido:';
        
        dependentesComCPFInvalido.forEach(dependente => {
          const cpfExibido = dependente.cpfDependente ? dependente.cpfDependente : '000.000.000-00';
          mensagem += `\n- ${dependente.nome}: ${cpfExibido}`;
        });
        
        mensagem += '\n\nPor favor, corrija o CPF de todos os dependentes antes de enviar o recadastramento.';
        
        this.$root.$refs.toastr.e(mensagem, 'CPF Inválido Detectado');
        return false;
      }
      
      return true;
    },
    getDadosParaComparacao() {
      const cadastroAtual = this.cadastrado.pessoa;
      const cadastroOriginal = this.$store.state.cadastroModelo.pessoa;

      return {
        // RG
        rg: {
          atual: cadastroAtual.rg ? this.normalizaRG(cadastroAtual.rg) : null,
          original: cadastroOriginal.rg ? this.normalizaRG(cadastroOriginal.rg) : null,
        },
        
        // Endereço
        endereco: {
          atual: this.normalizaEndereco(cadastroAtual.endereco || {}),
          original: this.normalizaEndereco(cadastroOriginal.endereco || {}),
        },
        
        // Contato
        contato: {
          atual: this.normalizaContato(cadastroAtual.contato || {}),
          original: this.normalizaContato(cadastroOriginal.contato || {}),
        },
        
        // Título de Eleitor
        tituloEleitor: {
          atual: cadastroAtual.tituloEleitor ? this.normalizaTitulo(cadastroAtual.tituloEleitor) : null,
          original: cadastroOriginal.tituloEleitor ? this.normalizaTitulo(cadastroOriginal.tituloEleitor) : null,
        },
        
        // Dados Pessoais
        dadosPessoais: {
          atual: this.normalizaDadosPessoais(cadastroAtual),
          original: this.normalizaDadosPessoais(cadastroOriginal),
        },
        
        // PIS/PASEP
        pisPasep: {
          atual: cadastroAtual.pisPasep ? String(cadastroAtual.pisPasep).replace(/\D/g, '') : null,
          original: cadastroOriginal.pisPasep ? String(cadastroOriginal.pisPasep).replace(/\D/g, '') : null,
        },
        
        // Órgão de Classe
        orgaoClasse: {
          atual: cadastroAtual.orgaoClasse ? this.normalizaOrgaoClasse(cadastroAtual.orgaoClasse) : null,
          original: cadastroOriginal.orgaoClasse ? this.normalizaOrgaoClasse(cadastroOriginal.orgaoClasse) : null,
        },
        
        // CNH
        cnh: {
          atual: cadastroAtual.cnh ? this.normalizaCNH(cadastroAtual.cnh) : null,
          original: cadastroOriginal.cnh ? this.normalizaCNH(cadastroOriginal.cnh) : null,
        },
        
        // Filiação (Pai e Mãe)
        filiacao: {
          pai: {
            //atual: cadastroAtual.filiacao?.pai || null,
            //original: cadastroOriginal.filiacao?.pai || null,
          },
          mae: {
            //atual: cadastroAtual.filiacao?.mae || null,
            //original: cadastroOriginal.filiacao?.mae || null,
          },
        },
        
        // Dependentes
        dependentes: {
          atual: cadastroAtual.dependentes || [],
          original: cadastroOriginal.dependentes || [],
        },
      };
    },
    verificarQuantidadeAnexos() {           
      if(this.situacaoInicial === 'RECADASTRAMENTO_PENDENTE') {
        if (this.totalAlteracoes > 0) {
            if(this.anexosTemporarios.length < this.totalAlteracoes) {
            this.$root.$refs.toastr.e(`Favor anexar todos os arquivos referentes às alterações realizadas.
              \nNumero de anexos: ${this.anexosTemporarios.length}\n\n
              Número de Alterações: ${this.totalAlteracoes}\n`, 'Erro', {timeOut:2000});
            return false;
          }
          return true;
        }
      }
      return true;
    },
    normalizaEndereco(endereco) {
      if (!endereco) return { 
        cep: '', 
        tipoLogradouro: '', 
        logradouro: '', 
        numero: '', 
        complemento: '', 
        bairro: '', 
        cidade: '', 
        uf: '',
        georreferenciado: false,
        inseridoPeloUsuario: false
      };
      
      return {
        cep: endereco.cep ? String(endereco.cep).replace(/\D/g, '') : '',
        tipoLogradouro: (endereco.tipoLogradouro || '').trim().toUpperCase(),
        logradouro: (endereco.logradouro || '').trim().toUpperCase(),
        numero: endereco.numero ? String(endereco.numero).replace(/\D/g, '') : '',
        complemento: (endereco.complemento || '').trim().toUpperCase(),
        bairro: (endereco.bairro || '').trim().toUpperCase(),
        cidade: (endereco.cidade || '').trim().toUpperCase(),
        uf: (endereco.uf || '').trim().toUpperCase(),
        georreferenciado: !!endereco.georreferenciado,
        inseridoPeloUsuario: !!endereco.inseridoPeloUsuario
      };
    },
    normalizaContato(contato) {
      if (!contato) return { 
        email: '', 
        dddCelular: '', 
        numeroCelular: '', 
        dddTelefone: '', 
        numeroTelefone: '' 
      };
      
      // Função auxiliar para limpar e converter para número
      const paraNumero = valor => {
        if (!valor) return '';
        const limpo = String(valor).replace(/\D/g, '');
        return limpo;
      };
      
      return {
        email: (contato.email || '').toLowerCase().trim(),
        dddCelular: paraNumero(contato.dddCelular),
        numeroCelular: paraNumero(contato.numeroCelular),
        dddTelefone: paraNumero(contato.dddTelefone),
        numeroTelefone: paraNumero(contato.numeroTelefone)
      };
    },
    normalizaDocumentos(pessoa) {
      if (!pessoa) return null;
      
      // Cria uma cópia profunda para não modificar o objeto original
      const pessoaNormalizada = JSON.parse(JSON.stringify(pessoa));
      
      try {
        // Normaliza RG
        if (pessoaNormalizada.rg) {
          pessoaNormalizada.rg = {
            numero: pessoaNormalizada.rg.numero ? String(pessoaNormalizada.rg.numero).replace(/\D/g, '') : '',
            dataEmissao: pessoaNormalizada.rg.dataEmissao || '',
            orgaoEmissor: pessoaNormalizada.rg.orgaoEmissor || '',
            uf: pessoaNormalizada.rg.uf || ''
          };
        }
        
        // Normaliza Título de Eleitor
        if (pessoaNormalizada.tituloEleitor) {
          pessoaNormalizada.tituloEleitor = {
            numero: pessoaNormalizada.tituloEleitor.numero ? parseInt(String(pessoaNormalizada.tituloEleitor.numero).replace(/\D/g, '')) || 0 : 0,
            zona: pessoaNormalizada.tituloEleitor.zona ? parseInt(String(pessoaNormalizada.tituloEleitor.zona).replace(/\D/g, '')) || 0 : 0,
            secao: pessoaNormalizada.tituloEleitor.secao ? parseInt(String(pessoaNormalizada.tituloEleitor.secao).replace(/\D/g, '')) || 0 : 0
          };
        }
        
        // Normaliza PIS/PASEP - IMPORTANTE: Converte para número inteiro
        if (pessoaNormalizada.pisPasep) {
          const pisPasepLimpo = String(pessoaNormalizada.pisPasep).replace(/\D/g, '');
          pessoaNormalizada.pisPasep = pisPasepLimpo ? parseInt(pisPasepLimpo) : null;
        }
        
        // Normaliza Órgão de Classe
        if (pessoaNormalizada.orgaoClasse) {
          pessoaNormalizada.orgaoClasse = {
            descricao: pessoaNormalizada.orgaoClasse.descricao || '',
            numero: pessoaNormalizada.orgaoClasse.numero || ''
          };
        }
        
        // Normaliza CNH
        if (pessoaNormalizada.cnh) {
          pessoaNormalizada.cnh = {
            numero: pessoaNormalizada.cnh.numero ? parseInt(String(pessoaNormalizada.cnh.numero).replace(/\D/g, '')) || 0 : 0,
            categoria: pessoaNormalizada.cnh.categoria || '',
            validade: pessoaNormalizada.cnh.validade || ''
          };
        }
      } catch (error) {
        console.error('Erro ao normalizar documentos completos:', error);
      }
      
      return pessoaNormalizada;
    },
    normalizaDadosPessoais(pessoa) {
      if (!pessoa) return {
        nome: '',
        dataNascimento: '', 
        racaCor: '', 
        estadoCivil: '', 
        naturalidade: {
          cidade: '',
          uf: ''
        },
        orientacaoSexual: '',
        genero: ''
      };
      
      return {
        nome: (pessoa.nome || '').trim().toUpperCase(),
        dataNascimento: pessoa.dataNascimento || '',
        racaCor: (pessoa.racaCor || '').trim(),
        estadoCivil: (pessoa.estadoCivil || '').trim(),
        naturalidade: {
          cidade: (pessoa.naturalidade && pessoa.naturalidade.cidade) ? pessoa.naturalidade.cidade.trim().toUpperCase() : '',
          uf: (pessoa.naturalidade && pessoa.naturalidade.uf) ? pessoa.naturalidade.uf.trim().toUpperCase() : ''
        },
        orientacaoSexual: (pessoa.orientacaoSexual || '').trim() ,
        genero: (pessoa.genero || '').trim() 
      };
    },
    verificaAlteracoes() {

      const cadastroModelo = this.$store.state.cadastroModelo;
      if (!cadastroModelo) return false;
      
      // Se o status já for diferente de RECADASTRAMENTO_PENDENTE, retorne true
      // para manter o comportamento atual e não mostrar o botão "Confirmar"
      if (this.cadastrado.status !== Status.RECADASTRAMENTO_PENDENTE) {
        return true;
      }
      
      // Verificação detalhada para documentos
      // RG
      const rgAtual = this.cadastrado.pessoa.rg ? this.cadastrado.pessoa.rg : null;
      const rgOriginal = cadastroModelo.pessoa.rg ? cadastroModelo.pessoa.rg : null;
      
      // Título de Eleitor
      const tituloAtual = this.cadastrado.pessoa.tituloEleitor ? this.cadastrado.pessoa.tituloEleitor : null;
      const tituloOriginal = cadastroModelo.pessoa.tituloEleitor ? cadastroModelo.pessoa.tituloEleitor : null;
      
      // PIS/PASEP
      const pisPasepAtual = this.cadastrado.pessoa.pisPasep;
      const pisPasepOriginal = cadastroModelo.pessoa.pisPasep;
      
      // Órgão de Classe
      const orgaoClasseAtual = this.cadastrado.pessoa.orgaoClasse ? this.cadastrado.pessoa.orgaoClasse : null;
      const orgaoClasseOriginal = cadastroModelo.pessoa.orgaoClasse ? cadastroModelo.pessoa.orgaoClasse : null;
      
      // CNH
      const cnhAtual = this.cadastrado.pessoa.cnh ? this.cadastrado.pessoa.cnh : null;
      const cnhOriginal = cadastroModelo.pessoa.cnh ? cadastroModelo.pessoa.cnh : null;
      
      // Verificação para filiação (nome do pai e da mãe)
      const paiAtual = this.cadastrado.pessoa.filiacao ? this.cadastrado.pessoa.filiacao.pai : null;
      const paiOriginal = cadastroModelo.pessoa.filiacao ? cadastroModelo.pessoa.filiacao.pai : null;
      
      const maeAtual = this.cadastrado.pessoa.filiacao ? this.cadastrado.pessoa.filiacao.mae : null;
      const maeOriginal = cadastroModelo.pessoa.filiacao ? cadastroModelo.pessoa.filiacao.mae : null;
      
      // Verificação para dependentes (Quadro Familiar)
      const dependentesAtuais = this.cadastrado.pessoa.dependentes || [];
      const dependentesOriginais = cadastroModelo.pessoa.dependentes || [];
      
      // Normaliza os dados para comparação
      const rgAtualNormalizado = this.normalizaRG(rgAtual);
      const rgOriginalNormalizado = this.normalizaRG(rgOriginal);
      
      const tituloAtualNormalizado = this.normalizaTitulo(tituloAtual);
      const tituloOriginalNormalizado = this.normalizaTitulo(tituloOriginal);
      
      const pisPasepAtualLimpo = pisPasepAtual ? String(pisPasepAtual).replace(/\D/g, '') : null;
      const pisPasepOriginalLimpo = pisPasepOriginal ? String(pisPasepOriginal).replace(/\D/g, '') : null;
      
      const orgaoClasseAtualNormalizado = this.normalizaOrgaoClasse(orgaoClasseAtual);
      const orgaoClasseOriginalNormalizado = this.normalizaOrgaoClasse(orgaoClasseOriginal);
      
      const cnhAtualNormalizado = this.normalizaCNH(cnhAtual);
      const cnhOriginalNormalizado = this.normalizaCNH(cnhOriginal);
      
      // Verifique se há alterações nos documentos
      const temAlteracoesRG = JSON.stringify(rgAtualNormalizado) !== JSON.stringify(rgOriginalNormalizado);
      const temAlteracoesTitulo = JSON.stringify(tituloAtualNormalizado) !== JSON.stringify(tituloOriginalNormalizado);
      const temAlteracoesPisPasep = pisPasepAtualLimpo !== pisPasepOriginalLimpo;
      const temAlteracoesOrgaoClasse = JSON.stringify(orgaoClasseAtualNormalizado) !== JSON.stringify(orgaoClasseOriginalNormalizado);
      const temAlteracoesCNH = JSON.stringify(cnhAtualNormalizado) !== JSON.stringify(cnhOriginalNormalizado);
      
      const temAlteracoesDocumentos = 
        temAlteracoesRG || 
        temAlteracoesTitulo || 
        temAlteracoesPisPasep ||
        temAlteracoesOrgaoClasse ||
        temAlteracoesCNH;
      
      //  Verifique se há alterações na filiação
      const temAlteracoesFiliacao = paiAtual !== paiOriginal || maeAtual !== maeOriginal;
      
      // Verifique se há alterações nos dependentes
      const temAlteracoesDependentes = JSON.stringify(dependentesAtuais) !== JSON.stringify(dependentesOriginais);
      
      // Adicione logs para facilitar a depuração de dependentes
      if (temAlteracoesDependentes) {
        console.log('Diferenças nos dependentes detectadas:');
        console.log('Dependentes atuais:', dependentesAtuais.length);
        console.log('Dependentes originais:', dependentesOriginais.length);
        
        // Se os números forem diferentes, já sabemos que houve mudança
        if (dependentesAtuais.length !== dependentesOriginais.length) {
          console.log('Quantidade de dependentes foi alterada');
        }
      }
      
      // Verificação detalhada para contatos
      const contatoAtual = this.normalizaContato(this.cadastrado.pessoa.contato || {});
      const contatoOriginal = this.normalizaContato(cadastroModelo.pessoa.contato || {});
      
      // Verifica cada campo individualmente para facilitar o debug
      const emailAlterado = contatoAtual.email !== contatoOriginal.email;
      const dddCelularAlterado = contatoAtual.dddCelular !== contatoOriginal.dddCelular;
      const numeroCelularAlterado = contatoAtual.numeroCelular !== contatoOriginal.numeroCelular;
      const dddTelefoneAlterado = contatoAtual.dddTelefone !== contatoOriginal.dddTelefone;
      const numeroTelefoneAlterado = contatoAtual.numeroTelefone !== contatoOriginal.numeroTelefone;
      
      const temAlteracoesContato = 
        emailAlterado || 
        dddCelularAlterado || 
        numeroCelularAlterado || 
        dddTelefoneAlterado || 
        numeroTelefoneAlterado;
      
      // Verifique alterações em raçaCor
      const racaCorAtual = this.cadastrado.pessoa.racaCor || '';
      const racaCorOriginal = cadastroModelo.pessoa.racaCor || '';
      
      const temAlteracoesRacaCor = racaCorAtual !== racaCorOriginal;
      
      // Verificação detalhada para endereço
      const enderecoAtual = this.normalizaEndereco(this.cadastrado.pessoa.endereco || {});
      const enderecoOriginal = this.normalizaEndereco(cadastroModelo.pessoa.endereco || {});
      
      // Verifica cada campo individualmente para facilitar o debug
      const cepAlterado = enderecoAtual.cep !== enderecoOriginal.cep;
      const tipoLogradouroAlterado = enderecoAtual.tipoLogradouro !== enderecoOriginal.tipoLogradouro;
      const logradouroAlterado = enderecoAtual.logradouro !== enderecoOriginal.logradouro;
      const numeroAlterado = enderecoAtual.numero !== enderecoOriginal.numero;
      const complementoAlterado = enderecoAtual.complemento !== enderecoOriginal.complemento;
      const bairroAlterado = enderecoAtual.bairro !== enderecoOriginal.bairro;
      const cidadeAlterado = enderecoAtual.cidade !== enderecoOriginal.cidade;
      const ufAlterado = enderecoAtual.uf !== enderecoOriginal.uf;
      const georreferenciadoAlterado = enderecoAtual.georreferenciado !== enderecoOriginal.georreferenciado;
      
      const temAlteracoesEndereco = 
        cepAlterado || 
        tipoLogradouroAlterado || 
        logradouroAlterado || 
        numeroAlterado || 
        complementoAlterado || 
        bairroAlterado || 
        cidadeAlterado || 
        ufAlterado ||
        georreferenciadoAlterado;

      // Verificação detalhada para dados pessoais
      const dadosPessoaisAtuais = this.normalizaDadosPessoais(this.cadastrado.pessoa);
      const dadosPessoaisOriginais = this.normalizaDadosPessoais(cadastroModelo.pessoa);
      
      // Verifica cada campo individualmente para facilitar o debug
      const nomeAlterado = dadosPessoaisAtuais.nome !== dadosPessoaisOriginais.nome;
      const dataNascimentoAlterada = dadosPessoaisAtuais.dataNascimento !== dadosPessoaisOriginais.dataNascimento;
      const racaCorAlterada = dadosPessoaisAtuais.racaCor !== dadosPessoaisOriginais.racaCor;
      const estadoCivilAlterado = dadosPessoaisAtuais.estadoCivil !== dadosPessoaisOriginais.estadoCivil;
      
      // Verificação de naturalidade
      const cidadeNatalidadeAlterada = dadosPessoaisAtuais.naturalidade.cidade !== dadosPessoaisOriginais.naturalidade.cidade;
      const ufNatalidadeAlterada = dadosPessoaisAtuais.naturalidade.uf !== dadosPessoaisOriginais.naturalidade.uf;
      
      // Verificação de orientação sexual e identidade de gênero
      const orientacaoSexualAlterada = JSON.stringify(dadosPessoaisAtuais.orientacaoSexual) !== JSON.stringify(dadosPessoaisOriginais.orientacaoSexual);
      const identidadeGeneroAlterada = JSON.stringify(dadosPessoaisAtuais.genero) !== JSON.stringify(dadosPessoaisOriginais.genero);


      const temAlteracoesDadosPessoais =
        nomeAlterado ||
        dataNascimentoAlterada || 
        racaCorAlterada || 
        estadoCivilAlterado || 
        cidadeNatalidadeAlterada || 
        ufNatalidadeAlterada ||
        orientacaoSexualAlterada ||
        identidadeGeneroAlterada;

      return temAlteracoesDocumentos || temAlteracoesFiliacao || temAlteracoesDependentes || temAlteracoesContato || temAlteracoesRacaCor || temAlteracoesEndereco || temAlteracoesDadosPessoais;
    },
    verificaMudancasAValidar(cadastroNovo, cadastroOriginal) {
      if (!cadastroNovo || !cadastroOriginal) return false;
      if (!cadastroNovo.pessoa || !cadastroOriginal.pessoa) return false;
      
      try {
        const pessoaAtual = this.normalizaDocumentos(cadastroNovo.pessoa);
        const pessoaOriginal = this.normalizaDocumentos(cadastroOriginal.pessoa);
        
        if (pessoaAtual.endereco) {
          pessoaAtual.endereco = this.normalizaEndereco(pessoaAtual.endereco);
        }
        
        if (pessoaOriginal.endereco) {
          pessoaOriginal.endereco = this.normalizaEndereco(pessoaOriginal.endereco);
        }
        
        delete pessoaAtual.contato;
        delete pessoaAtual.racaCor;
        delete pessoaOriginal.contato;
        delete pessoaOriginal.racaCor;
        
        const strPessoaAtual = JSON.stringify(pessoaAtual);
        const strPessoaOriginal = JSON.stringify(pessoaOriginal);
        
        return strPessoaAtual !== strPessoaOriginal;
      } catch (error) {
        console.error('Erro ao verificar mudanças que precisam de validação:', error);
        return false;
      }
    },
    verificaMudancasSemValidacao(cadastroNovo, cadastroOriginal) {
      if (!cadastroNovo || !cadastroOriginal) return false;
      if (!cadastroNovo.pessoa || !cadastroOriginal.pessoa) return false;
      
      try {
        const contatoAtual = this.normalizaContato(cadastroNovo.pessoa.contato || {});
        const contatoOriginal = this.normalizaContato(cadastroOriginal.pessoa.contato || {});
        
        const racaCorAtual = cadastroNovo.pessoa.racaCor || '';
        const racaCorOriginal = cadastroOriginal.pessoa.racaCor || '';
        
        const strContatoAtual = JSON.stringify(contatoAtual);
        const strContatoOriginal = JSON.stringify(contatoOriginal);
        const strRacaCorAtual = JSON.stringify(racaCorAtual);
        const strRacaCorOriginal = JSON.stringify(racaCorOriginal);
        
        return strContatoAtual !== strContatoOriginal || strRacaCorAtual !== strRacaCorOriginal;
      } catch (error) {
        console.error('Erro ao verificar mudanças sem validação:', error);
        return false;
      }
    },
    normalizaCamposData(obj) {
      if (!obj) return;
      
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          
          if (typeof value === 'object' && value !== null) {
            this.normalizaCamposData(value);
          }
          
          if (typeof value === 'string' && 
              (value.includes('/') || value.includes('-') || value.match(/^\d{4}/) || value.match(/^\d{2}/))) {
            try {
              const date = new Date(value.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1'));
              if (!isNaN(date.getTime())) {
                obj[key] = date.toISOString().split('T')[0];
              }
            } catch (e) {
              // Ignora erros de conversão
            }
          }
        }
      }
    },
    atualizaStatusParaEnvio() {
      //console.log('atualizaStatusParaEnvio - Status atual:', this.cadastrado.status);
      
      // Se o status já for CONFIRMADO ou VALIDADO, não altere
      if (this.cadastrado.status === Status.CONFIRMADO || 
          this.cadastrado.status === Status.VALIDADO || 
          this.cadastrado.status === Status.PENDENTE_VALE_TRANSPORTE) {
        console.log('Status já finalizado, não será alterado');
        return;
      }
      
      // Se o status já for diferente de RECADASTRAMENTO_PENDENTE, vamos verificar
      // se realmente existem alterações para mantê-lo
      if (this.cadastrado.status !== Status.RECADASTRAMENTO_PENDENTE) {
        const temAlteracoes = this.verificaAlteracoes();
        if (!temAlteracoes) {
         // console.log('Não há alterações, status será redefinido para RECADASTRAMENTO_PENDENTE');
          this.cadastrado.status = Status.RECADASTRAMENTO_PENDENTE;
          this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
          this.$store.dispatch('updateSituacaoRecad', Status.RECADASTRAMENTO_PENDENTE);
          return;
        }
        
        console.log('Status atual será mantido pois existem alterações');
        return;
      }
      
      // Verificação detalhada para documentos
      // RG
      const rgAtual = this.cadastrado.pessoa.rg ? this.cadastrado.pessoa.rg : null;
      const rgOriginal = this.$store.state.cadastroModelo.pessoa.rg ? this.$store.state.cadastroModelo.pessoa.rg : null;
      
      // Título de Eleitor
      const tituloAtual = this.cadastrado.pessoa.tituloEleitor ? this.cadastrado.pessoa.tituloEleitor : null;
      const tituloOriginal = this.$store.state.cadastroModelo.pessoa.tituloEleitor ? this.$store.state.cadastroModelo.pessoa.tituloEleitor : null;
      
      // PIS/PASEP
      const pisPasepAtual = this.cadastrado.pessoa.pisPasep;
      const pisPasepOriginal = this.$store.state.cadastroModelo.pessoa.pisPasep;
      
      // Órgão de Classe
      const orgaoClasseAtual = this.cadastrado.pessoa.orgaoClasse ? this.cadastrado.pessoa.orgaoClasse : null;
      const orgaoClasseOriginal = this.$store.state.cadastroModelo.pessoa.orgaoClasse ? this.$store.state.cadastroModelo.pessoa.orgaoClasse : null;
      
      // CNH
      const cnhAtual = this.cadastrado.pessoa.cnh ? this.cadastrado.pessoa.cnh : null;
      const cnhOriginal = this.$store.state.cadastroModelo.pessoa.cnh ? this.$store.state.cadastroModelo.pessoa.cnh : null;
      
      // Verificação para filiação (nome do pai e da mãe)
      const paiAtual = this.cadastrado.pessoa.filiacao ? this.cadastrado.pessoa.filiacao.pai : null;
      const paiOriginal = this.$store.state.cadastroModelo.pessoa.filiacao ? this.$store.state.cadastroModelo.pessoa.filiacao.pai : null;
      
      const maeAtual = this.cadastrado.pessoa.filiacao ? this.cadastrado.pessoa.filiacao.mae : null;
      const maeOriginal = this.$store.state.cadastroModelo.pessoa.filiacao ? this.$store.state.cadastroModelo.pessoa.filiacao.mae : null;
      
      // Verificação para dependentes (Quadro Familiar)
      const dependentesAtuais = this.cadastrado.pessoa.dependentes || [];
      const dependentesOriginais = this.$store.state.cadastroModelo.pessoa.dependentes || [];
      
      // Normaliza os dados para comparação
      const rgAtualNormalizado = this.normalizaRG(rgAtual);
      const rgOriginalNormalizado = this.normalizaRG(rgOriginal);
      
      const tituloAtualNormalizado = this.normalizaTitulo(tituloAtual);
      const tituloOriginalNormalizado = this.normalizaTitulo(tituloOriginal);
      
      const pisPasepAtualLimpo = pisPasepAtual ? String(pisPasepAtual).replace(/\D/g, '') : null;
      const pisPasepOriginalLimpo = pisPasepOriginal ? String(pisPasepOriginal).replace(/\D/g, '') : null;
      
      const orgaoClasseAtualNormalizado = this.normalizaOrgaoClasse(orgaoClasseAtual);
      const orgaoClasseOriginalNormalizado = this.normalizaOrgaoClasse(orgaoClasseOriginal);
      
      const cnhAtualNormalizado = this.normalizaCNH(cnhAtual);
      const cnhOriginalNormalizado = this.normalizaCNH(cnhOriginal);
      
      // Verifique se há alterações nos documentos
      const temAlteracoesRG = JSON.stringify(rgAtualNormalizado) !== JSON.stringify(rgOriginalNormalizado);
      const temAlteracoesTitulo = JSON.stringify(tituloAtualNormalizado) !== JSON.stringify(tituloOriginalNormalizado);
      const temAlteracoesPisPasep = pisPasepAtualLimpo !== pisPasepOriginalLimpo;
      const temAlteracoesOrgaoClasse = JSON.stringify(orgaoClasseAtualNormalizado) !== JSON.stringify(orgaoClasseOriginalNormalizado);
      const temAlteracoesCNH = JSON.stringify(cnhAtualNormalizado) !== JSON.stringify(cnhOriginalNormalizado);
      
      const temAlteracoesDocumentos = 
        temAlteracoesRG || 
        temAlteracoesTitulo || 
        temAlteracoesPisPasep ||
        temAlteracoesOrgaoClasse ||
        temAlteracoesCNH;
      
      // Verifique se há alterações na filiação
      const temAlteracoesFiliacao = paiAtual !== paiOriginal || maeAtual !== maeOriginal;
      
      // Verifique se há alterações nos dependentes
      const temAlteracoesDependentes = JSON.stringify(dependentesAtuais) !== JSON.stringify(dependentesOriginais);
      
      // Verificação detalhada para contatos
      const contatoAtual = this.normalizaContato(this.cadastrado.pessoa.contato || {});
      const contatoOriginal = this.normalizaContato(this.$store.state.cadastroModelo.pessoa.contato || {});
      
      // Verifica cada campo individualmente para facilitar o debug
      const emailAlterado = contatoAtual.email !== contatoOriginal.email;
      const dddCelularAlterado = contatoAtual.dddCelular !== contatoOriginal.dddCelular;
      const numeroCelularAlterado = contatoAtual.numeroCelular !== contatoOriginal.numeroCelular;
      const dddTelefoneAlterado = contatoAtual.dddTelefone !== contatoOriginal.dddTelefone;
      const numeroTelefoneAlterado = contatoAtual.numeroTelefone !== contatoOriginal.numeroTelefone;
      
      const temAlteracoesContato = 
        emailAlterado || 
        dddCelularAlterado || 
        numeroCelularAlterado || 
        dddTelefoneAlterado || 
        numeroTelefoneAlterado;
      
      // Verifique alterações em raçaCor
      const racaCorAtual = this.cadastrado.pessoa.racaCor || '';
      const racaCorOriginal = this.$store.state.cadastroModelo.pessoa.racaCor || '';
      
      const temAlteracoesRacaCor = racaCorAtual !== racaCorOriginal;
      
      // Verificação detalhada para endereço
      const enderecoAtual = this.normalizaEndereco(this.cadastrado.pessoa.endereco || {});
      const enderecoOriginal = this.normalizaEndereco(this.$store.state.cadastroModelo.pessoa.endereco || {});
      
      // Verifica cada campo individualmente para facilitar o debug
      const cepAlterado = enderecoAtual.cep !== enderecoOriginal.cep;
      const tipoLogradouroAlterado = enderecoAtual.tipoLogradouro !== enderecoOriginal.tipoLogradouro;
      const logradouroAlterado = enderecoAtual.logradouro !== enderecoOriginal.logradouro;
      const numeroAlterado = enderecoAtual.numero !== enderecoOriginal.numero;
      const complementoAlterado = enderecoAtual.complemento !== enderecoOriginal.complemento;
      const bairroAlterado = enderecoAtual.bairro !== enderecoOriginal.bairro;
      const cidadeAlterado = enderecoAtual.cidade !== enderecoOriginal.cidade;
      const ufAlterado = enderecoAtual.uf !== enderecoOriginal.uf;
      const georreferenciadoAlterado = enderecoAtual.georreferenciado !== enderecoOriginal.georreferenciado;
      
      const temAlteracoesEndereco = 
        cepAlterado || 
        tipoLogradouroAlterado || 
        logradouroAlterado || 
        numeroAlterado || 
        complementoAlterado || 
        bairroAlterado || 
        cidadeAlterado || 
        ufAlterado ||
        georreferenciadoAlterado;
      
      // Verificação detalhada para dados pessoais
      const dadosPessoaisAtuais = this.normalizaDadosPessoais(this.cadastrado.pessoa);
      const dadosPessoaisOriginais = this.normalizaDadosPessoais(this.$store.state.cadastroModelo.pessoa);
      
      // Verifica cada campo individualmente para facilitar o debug
      const nomeAlterado = dadosPessoaisAtuais.nome !== dadosPessoaisOriginais.nome;
      const dataNascimentoAlterada = dadosPessoaisAtuais.dataNascimento !== dadosPessoaisOriginais.dataNascimento;
      const racaCorAlterada = dadosPessoaisAtuais.racaCor !== dadosPessoaisOriginais.racaCor;
      const estadoCivilAlterado = dadosPessoaisAtuais.estadoCivil !== dadosPessoaisOriginais.estadoCivil;
      
      // Verificação de naturalidade
      const cidadeNatalidadeAlterada = dadosPessoaisAtuais.naturalidade.cidade !== dadosPessoaisOriginais.naturalidade.cidade;
      const ufNatalidadeAlterada = dadosPessoaisAtuais.naturalidade.uf !== dadosPessoaisOriginais.naturalidade.uf;
      
      // Verificação de orientação sexual e identidade de gênero
      const orientacaoSexualAlterada = JSON.stringify(dadosPessoaisAtuais.orientacaoSexual) !== JSON.stringify(dadosPessoaisOriginais.orientacaoSexual);
      const identidadeGeneroAlterada = JSON.stringify(dadosPessoaisAtuais.genero) !== JSON.stringify(dadosPessoaisOriginais.genero);
      console.log
      const temAlteracoesDadosPessoais = 
        nomeAlterado ||
        dataNascimentoAlterada || 
        racaCorAlterada || 
        estadoCivilAlterado || 
        cidadeNatalidadeAlterada || 
        ufNatalidadeAlterada ||
        orientacaoSexualAlterada ||
        identidadeGeneroAlterada;
      
      // Log para ajudar na depuração
      if (temAlteracoesDependentes) {
        console.log('Detectada alteração nos dependentes');
      }
      
      // Defina o status com base nas alterações
      if (temAlteracoesDocumentos || temAlteracoesFiliacao || temAlteracoesDependentes || dataNascimentoAlterada || estadoCivilAlterado || cidadeNatalidadeAlterada || ufNatalidadeAlterada || nomeAlterado) {
        console.log('Alterações exigem validação (COM_VALIDACAO)');
        this.cadastrado.status = Status.COM_VALIDACAO;
      } else if (temAlteracoesContato || racaCorAlterada || orientacaoSexualAlterada || identidadeGeneroAlterada || temAlteracoesEndereco) {
        console.log('Alterações não exigem validação (SEM_VALIDACAO)');
        this.cadastrado.status = Status.SEM_VALIDACAO;
      } else {
        console.log('Não há alterações (RECADASTRAMENTO_PENDENTE)');
        this.cadastrado.status = Status.RECADASTRAMENTO_PENDENTE;
      }
      
      this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
      this.$store.dispatch('updateSituacaoRecad', this.cadastrado.status);
    },
    volta() {
      this.$router.go(-1);
    },
    chamaComponente(nomeComponente) {
      this.$router.push({ name: nomeComponente });
    },
    confirma(cadastrado) {
      // Verifica os CPFs dos dependentes antes de prosseguir
      if (!this.verificaCPFsDependentes()) {
        return;
      }

       if (!this.verificarQuantidadeAnexos()) {
         return;
       }
      // Formata os números de telefone antes de enviar
      this.formataNumerosContato(cadastrado);

      let status = cadastrado.checkValetransporteEndereco ? Status.PENDENTE_VALE_TRANSPORTE : Status.CONFIRMADO;
      this.$store.dispatch('updateSituacaoRecad', status);

      this.salvaRecadastramento(
        cadastrado,
        cadastrado.status,
        status,
        true,
      );
    },
    salvaValidado(cadastrado) {
      // Verifica os CPFs dos dependentes antes de prosseguir
      if (!this.verificaCPFsDependentes()) {
        return;
      }
      
      if (!this.verificarQuantidadeAnexos()) {
         return;
       }
      // Formata os números de telefone antes de enviar
      this.formataNumerosContato(cadastrado);

      let status = cadastrado.checkValetransporteEndereco ? Status.PENDENTE_VALE_TRANSPORTE : Status.VALIDADO;
      this.$store.dispatch('updateSituacaoRecad', status);

      this.salvaRecadastramento(
        cadastrado,
        cadastrado.status,
        status,
        true,
      );
    },
    atualizaEnderecoLocal(endereco) {
      if (this.cadastrado && this.cadastrado.pessoa) {
        this.cadastrado.pessoa.endereco = endereco;
      }
    },
    async salvaAlterado(cadastrado) {
      // Verifica os CPFs dos dependentes antes de prosseguir
      if (!this.verificaCPFsDependentes()) {
        return;
      }
      
      if (!this.verificarQuantidadeAnexos()) {
         return;
       }
      // Formata os números de telefone antes de enviar
      this.formataNumerosContato(cadastrado);
      
      let status = cadastrado.checkValetransporteEndereco ? 
        Status.PENDENTE_VALE_TRANSPORTE : 
        Status.ALTERADO;
      
      this.$store.dispatch('updateSituacaoRecad', status);

      await this.salvaRecadastramento(
        cadastrado,
        cadastrado.status,
        status,
        true,
      );
    },
    async salvaRecadastramento(
      cadastrado,
      statusPrimario,
      statusNovo,
      finaliza,
    ) {
      // Verifica os CPFs dos dependentes antes de prosseguir
      if (!this.verificaCPFsDependentes()) {
        return;
      }
      
      if (!this.verificarQuantidadeAnexos()) {
         return;
       }

      // Valida email obrigatório (exceto se for email da prefeitura)
      const cadastroModelo = this.$store.state.cadastroModelo;
      const emailOriginal = cadastroModelo && cadastroModelo.pessoa && cadastroModelo.pessoa.contato && cadastroModelo.pessoa.contato.email;
      const ehEmailPrefeitura = emailOriginal && emailOriginal.includes('@santos.sp.gov.br');
      if (!ehEmailPrefeitura) {
        const email = cadastrado && cadastrado.pessoa && cadastrado.pessoa.contato && cadastrado.pessoa.contato.email;
        if (!email || email.trim() === '') {
          this.$root.$refs.toastr.e('O campo Email é obrigatório', 'Atenção');
          this.$router.push({ name: 'Contatos' });
          return;
        }
      }

      try {
        this.salvando = true;
        cadastrado.status = statusNovo;
        this.$store.dispatch('updateSituacaoRecad', statusNovo);
        
        // Formata os números de telefone antes de enviar
        this.formataNumerosContato(cadastrado);
        
        const response = await RecadastramentoService.grava(
          cadastrado.id,
          cadastrado,
        );
        
        const cadastroAlterado = await response;
        const temMultiplosRegistros = this.cadastrado.mostraMultiplosRegistros;
        this.cadastrado = cadastroAlterado;
        this.cadastrado.mostraMultiplosRegistros = temMultiplosRegistros;
        this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
        this.$store.dispatch('updateSituacaoRecad', this.cadastrado.status);
        
        const cadastradoModelo = JSON.parse(JSON.stringify(this.cadastrado));
        this.$store.commit('setCadastroModelo', cadastradoModelo);
        
        if (finaliza) {
          this.$router.push({ name: 'Fim' });
        }
        this.$root.$refs.toastr.s('Atualização Cadastral enviada', 'Sucesso');
        this.salvando = false;
      } catch (error) {
        cadastrado.status = statusPrimario;
        this.$store.dispatch('updateSituacaoRecad', statusPrimario);
        const mensagem = ErrorHelper.trataMensagem(error);
        console.log( `Erro ao salvar recadastramento: ${mensagem}`);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
        this.salvando = false;
      }
    },
    selecionaArquivo() {
      if (this.verificaAlteracoes()) {
        this.abreModal('upload');
        this.cadastrado.status = Status.ALTERADO;
        this.$store.dispatch('updateSituacaoRecad', Status.ALTERADO);
      } else {
        this.$root.$refs.toastr.i('Não há alterações para anexar documentos', 'Informação');
      }
    },
    enviaArquivo(cadastrado) {
     // console.log(`Anexos Ref: ${this.$refs.uploader.arquivosParaEnviar}`);
      this.anexosTemporarios.push(
        ...this.$refs.uploader.arquivosParaEnviar,
      );
      this.cadastrado.anexos = [...this.cadastrado.anexos, ...this.anexosTemporarios]
      // console.log(`Anexos Temporario: ${this.anexosTemporarios}`);
      // console.log(`Anexos: ${this.cadastrado.anexos}`);
      this.$eventBus.$emit('salva-arquivos');
    },
    finalizaUpload() {
      this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
      this.$store.dispatch('updateSituacaoRecad', this.cadastrado.status);
      this.fechaModal('upload');
    },
    incluiMensagem(documentosApi, documentosLocal) {
      if (!documentosLocal) documentosLocal = [];
      
      // Primeiro, remover todos os documentos de dependentes que possam estar na lista
      // para evitar duplicações quando houver alterações de tipo
      documentosLocal = documentosLocal.filter(doc => 
        !doc.includes('Certidão de Nascimento ou de Óbito do parente') &&
        !doc.includes('Certidão de Casamento Averbada') && 
        !doc.includes('Escritura de União Estável')
      );
      
      // Usar um Set para controlar quais documentos serão adicionados
      const docsParaAdicionar = new Set();
      
      // Flag para verificar se temos alterações nos dependentes
      let temAlteracoesDependentes = false;
      
      // Verificar se houve alterações nos dependentes (antes do loop principal)
      if (this.cadastrado && this.cadastrado.pessoa && 
          this.$store.state.cadastroModelo && this.$store.state.cadastroModelo.pessoa) {
        
        const dependentesAtuais = this.cadastrado.pessoa.dependentes || [];
        const dependentesOriginais = this.$store.state.cadastroModelo.pessoa.dependentes || [];
        
        // Verifica se há diferença no número de dependentes
        if (dependentesAtuais.length !== dependentesOriginais.length) {
          temAlteracoesDependentes = true;
        } else {
          // Verifica se algum dependente foi modificado
          dependentesAtuais.forEach(depAtual => {
            const depOriginal = dependentesOriginais.find(d => d.id === depAtual.id);
            if (!depOriginal || JSON.stringify(depOriginal) !== JSON.stringify(depAtual)) {
              temAlteracoesDependentes = true;
            }
          });
        }
      }
      
      documentosApi.forEach(element => {
        switch (element.grupo) {
          case 'cnh':
            docsParaAdicionar.add('Carteira de Habilitação');
            break;
          case 'dependentes':
            temAlteracoesDependentes = true; // Se o grupo dependentes está explicitamente marcado, há alterações
            break;
          case 'dataNascimento':
            docsParaAdicionar.add(
              'RG ou Certidão de Nascimento ou Decisão Judicial'
            );
            break;
          case 'naturalidade':
            docsParaAdicionar.add(
              'RG ou Certidão de Nascimento ou Decisão Judicial'
            );
            break;
          case 'estadoCivil':
            docsParaAdicionar.add('Certidão de Casamento (a mais recente)');
            break;
          case 'filiacao':
            docsParaAdicionar.add(
              'RG ou Certidão de Nascimento ou Decisão Judicial'
            );
            break;
          case 'endereco':
            docsParaAdicionar.add(
              'Comprovante de Residência recente (com menos de 90 dias)'
            );
            break;
          case 'rg':
            docsParaAdicionar.add('RG (caso ainda não estiver anexado)');
            break;
          case 'tituloEleitor':
            docsParaAdicionar.add('Título de Eleitor');
            break;
          case 'pisPasep':
            docsParaAdicionar.add('PIS/PASEP');
            break;
          case 'orgaoClasse':
            docsParaAdicionar.add('Documento oficial do Conselho de Classe');
            break;
          default:
            break;
        }
      });
      
      // Se foi detectada alteração em dependentes, processar independente de estar nos grupos
      if (temAlteracoesDependentes && this.cadastrado && this.cadastrado.pessoa && 
          this.cadastrado.pessoa.dependentes && this.$store.state.cadastroModelo && 
          this.$store.state.cadastroModelo.pessoa) {
        
        const dependentesAtuais = this.cadastrado.pessoa.dependentes || [];
        const dependentesOriginais = this.$store.state.cadastroModelo.pessoa.dependentes || [];
        
        // Para cada dependente atual, verificar documentos necessários
        dependentesAtuais.forEach(depAtual => {
          const depOriginal = dependentesOriginais.find(d => d.id === depAtual.id);
          
          // Se é novo OU se foi alterado
          if (!depOriginal || JSON.stringify(depOriginal) !== JSON.stringify(depAtual)) {
            const tipoDesc = depAtual.tipo && depAtual.tipo.descricao ? depAtual.tipo.descricao.toUpperCase() : '';
            
            if (tipoDesc.includes('COMPANHEIRO') || tipoDesc.includes('COMPANHEIRA')) {
              docsParaAdicionar.add('Escritura de União Estável');
            } else if (tipoDesc.includes('ESPOSO') || tipoDesc.includes('ESPOSA')) {
              docsParaAdicionar.add('Certidão de Casamento Averbada');
            } else if (tipoDesc) { // Só adiciona se tiver algum tipo definido
              docsParaAdicionar.add('Certidão de Nascimento ou de Óbito do parente');
            }
          }
        });
        
        // Se não houve documentos adicionados para dependentes, mas há alterações
        // (por exemplo, um dependente foi removido), adicionar documento padrão
        const temDocumentoDependente = Array.from(docsParaAdicionar).some(
          doc => doc.includes('Certidão') || doc.includes('Escritura')
        );
        
        if (!temDocumentoDependente && dependentesAtuais.length > 0) {
          docsParaAdicionar.add('Certidão de Nascimento ou de Óbito do parente');
        }
      }
      
      // Adicionar os documentos acumulados ao array de documentosLocal
      docsParaAdicionar.forEach(doc => documentosLocal.push(doc));
      
      return documentosLocal;
    },
    gravaPessoaEndereco(editado) {
      try {
        if (!editado.cidade || !editado.uf) {
          throw new Error('Dados de endereço incompletos');
        }

        this.cadastrado.pessoa.endereco = {
          ...editado,
          numero: parseInt(editado.numero) || 0
        };

        this.tiraAcentuacao(this.cadastrado.pessoa.endereco);
        this.setAnexos(this.cadastrado, this.$store.state.cadastroModelo);
        this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
        return true;
      } catch (error) {
        this.$root.$refs.toastr.e('Erro ao salvar endereço', 'Erro');
        return false;
      }
    },
    forcaVerificacaoStatus() {
      console.log('Forçando verificação de status...');
      
      const temAlteracoes = this.verificaAlteracoes();
      //console.log('Tem alterações:', temAlteracoes);
      //console.log(`Anexos temporários: ${this.anexosTemporarios}`);
      
      if (!temAlteracoes) {
        console.log('Definindo status como RECADASTRAMENTO_PENDENTE');
        this.cadastrado.status = Status.RECADASTRAMENTO_PENDENTE;
        this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
        this.$store.dispatch('updateSituacaoRecad', Status.RECADASTRAMENTO_PENDENTE);
        this.$forceUpdate();
      } else {
        console.log('Atualizando status com base nas alterações');
        this.atualizaStatusParaEnvio();
      }
    },
    redefinirCadastroModelo() {
      console.log('Redefinindo cadastro modelo...');
      const cadastroAtual = JSON.parse(JSON.stringify(this.cadastrado));
      this.$store.commit('setCadastroModelo', cadastroAtual);
      console.log('Cadastro modelo redefinido');
    },
    // Métodos auxiliares para normalização de documentos
    normalizaRG(rg) {
      if (!rg) return { numero: '', dataEmissao: '', orgaoEmissor: '', uf: '' };
      
      return {
        numero: rg.numero ? String(rg.numero).replace(/\D/g, '') : '',
        dataEmissao: rg.dataEmissao || '',
        orgaoEmissor: rg.orgaoEmissor || '',
        uf: rg.uf || ''
      };
    },
    normalizaTitulo(titulo) {
      if (!titulo) return { numero: '', zona: '', secao: '' };
      
      return {
        numero: titulo.numero ? String(titulo.numero).replace(/\D/g, '') : '',
        zona: titulo.zona ? String(titulo.zona).replace(/\D/g, '') : '',
        secao: titulo.secao ? String(titulo.secao).replace(/\D/g, '') : ''
      };
    },
    normalizaOrgaoClasse(orgaoClasse) {
      if (!orgaoClasse) return { descricao: '', numero: '' };
      
      return {
        descricao: orgaoClasse.descricao || '',
        numero: orgaoClasse.numero ? String(orgaoClasse.numero).replace(/\D/g, '') : ''
      };
    },
    normalizaCNH(cnh) {
      if (!cnh) return { numero: '', categoria: '', validade: '' };
      
      return {
        numero: cnh.numero ? String(cnh.numero).replace(/\D/g, '') : '',
        categoria: cnh.categoria || '',
        validade: cnh.validade || ''
      };
    },
    formataNumerosContato(cadastrado) {
      // Verifica se existe pessoa e contato antes de tentar formatar
      if (!cadastrado || !cadastrado.pessoa || !cadastrado.pessoa.contato) return;
      
      const contato = cadastrado.pessoa.contato;
      
      // Função para limpar formatação (remove caracteres não numéricos)
      const limpaFormato = valor => {
        if (!valor) return null;
        return String(valor).replace(/\D/g, '');
      };
      
      // Função para converter para número inteiro
      const paraNumeroPossivelmente = valor => {
        if (!valor) return null;
        const limpo = limpaFormato(valor);
        return limpo ? Number(limpo) : null;
      };
      
      // Aplica a limpeza e conversão em todos os campos numéricos do contato
      contato.numeroCelular = paraNumeroPossivelmente(contato.numeroCelular);
      contato.numeroTelefone = paraNumeroPossivelmente(contato.numeroTelefone);
      contato.dddCelular = paraNumeroPossivelmente(contato.dddCelular);
      contato.dddTelefone = paraNumeroPossivelmente(contato.dddTelefone);
    },
  },

  created() {
    //this.limparEstadoLocal();
    this.situacaoInicial = this.$store.state.situacaoRecad;
    console.log("Situacao Inicial:", this.situacaoInicial);
    console.log(this.determinarBotao());
    this.endPointUpload = `recadastramento-servidores/${this.cadastrado.id}/anexos`;
    this.navs[0].titulo = this.tituloResponsivo;
    this.cadastrado.pessoa = StringHelper.toUpperCaseInJson(
      this.cadastrado.pessoa,
      ['email'],
    );
    
    if (!this.$store.state.cadastroModelo) {
      console.log('Criando cadastroModelo inicial');
      const cadastroInicial = JSON.parse(JSON.stringify(this.cadastrado));
      this.$store.commit('setCadastroModelo', cadastroInicial);
    }
    
    console.log('Forçando verificação inicial de status');
    this.forcaVerificacaoStatus();
    
    this.$eventBus.$on('dispensaUploader', () => this.finalizaUpload());
    this.$eventBus.$on('salvaAvanca', nomeComponente => {
      this.chamaComponente(nomeComponente);
    });
    this.$on('atualizaEnderecoLocal', this.atualizaEnderecoLocal);
    
    this.$nextTick(() => {
      this.$forceUpdate();
    });
  },

  mounted() {
    window.scrollTo(0, 0);
  },
  mutations: {
    limparAnexos(state) {
      if (state.funcionarioCadastrado !== undefined &&
      state.funcionarioCadastrado !== null &&
      state.funcionarioCadastrado.anexos) {
        state.funcionarioCadastrado.anexos = []; // Limpa o array
      }
    }
 },
  beforeDestroy() {
    this.limparEstadoLocal();
    this.$eventBus.$off('dispensaUploader');
    this.$eventBus.$off('salvaAvanca');
    this.$off('atualizaEnderecoLocal');
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log('beforeRouteEnter - Entrando na rota Envio');
      console.log('Rota anterior:', from.path);
      
      // Se estiver vindo da página de documentação ou filiação, redefina o cadastro modelo
      if (from.path.includes('documentacao') || from.path.includes('filiacao')) {
        console.log('Vindo de página que pode ter alterações, redefinindo cadastro modelo');
        // Não redefina todo o modelo, apenas force a verificação do status
        vm.forcaVerificacaoStatus();
      } else if (!vm.$store.state.cadastroModelo) {
        console.log('Criando cadastroModelo na entrada da rota');
        const cadastroInicial = JSON.parse(JSON.stringify(vm.cadastrado));
        vm.$store.commit('setCadastroModelo', cadastroInicial);
        vm.forcaVerificacaoStatus();
      } else {
        // Force a verificação de status em todos os casos
        vm.forcaVerificacaoStatus();
      }
    });
  },

  watch: {
    'cadastrado.status': {
      immediate: true,
      handler(newStatus, oldStatus) {
        console.log(`Status alterado: ${oldStatus} -> ${newStatus}`);
        this.$store.dispatch('updateSituacaoRecad', newStatus);
        
        if (newStatus !== Status.RECADASTRAMENTO_PENDENTE && !this.verificaAlteracoes()) {
          console.log('Forçando status para RECADASTRAMENTO_PENDENTE no watcher');
          this.cadastrado.status = Status.RECADASTRAMENTO_PENDENTE;
          this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
          this.$store.dispatch('updateSituacaoRecad', Status.RECADASTRAMENTO_PENDENTE);
          
          this.$forceUpdate();
        }
      }
    }
  }
};
</script>

<style scoped>
.espacado {
  margin: 44px 0 48px;
}

.multiplos-botoes {
  display: flex;
  justify-content: space-evenly;
}
</style>


// WEBPACK FOOTER //
// index.vue?9ee03b7a